import { PageLayout, useBrowserTitle } from '@acp/core-ui';
import React, { Suspense } from 'react';

const UpdatePage = React.lazy(() => import('../features/action-required/update/page'));

export function UpdatePropertiesView() {
    useBrowserTitle('Update Required');

    return (
        <Suspense fallback={<PageLayout.Skeleton sidebar aside controls />}>
            <UpdatePage />
        </Suspense>
    );
}
